import React from 'react'

import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { toPx } from 'common/builder/components/chart/utils/toPx'

const defaultStyles: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  flexGrow: 1,
  height: toPx(36),
  marginTop: toPx(sharedStyles.Spacings.MEDIUM),
  paddingRight: toPx(sharedStyles.Spacings.MEDIUM),
}

const hoverStyles: React.CSSProperties = {
  ...defaultStyles,
}

export const styles = {
  default: defaultStyles,
  hover: hoverStyles,
}
